import { isRejectedWithValue } from "@reduxjs/toolkit";
import type { Middleware } from "@reduxjs/toolkit";
import { isRecord } from "./guards";
import { userSlice } from "../redux/slices/user";

export const rtkQueryErrorWatcher: Middleware =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    if (isRejectedWithValue(action)) {
      if (
        "payload" in action &&
        isRecord(action.payload) &&
        "status" in action.payload &&
        action.payload.status === 401
      ) {
        dispatch(userSlice.actions.setToken(null));
      }
    }
    return next(action);
  };
